<script setup>
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { Button } from '@/components/ui/button'

// This is how you allow a component to refer to itself in <script setup>
defineOptions({
  name: 'RecursiveNav'
})

const emit = defineEmits(['navigate'])

async function navigateToItem(event, navigate) {
  await navigate(event)
  emit('navigate')
}

// Get the navigation items array
defineProps({
  items: {
    type: Array,
    default: () => []
  },
  orientation: {
    type: String,
    default: 'vertical',
    validator: value => ['vertical', 'horizontal'].includes(value),
  },
})
</script>

<template>
  <div :class="orientation === 'horizontal' ? 'flex flex-wrap items-center gap-2' : 'flex flex-col gap-1'">
    <template v-for="item in items" :key="item.title">
      <RouterLink v-if="!item.children || item.children.length === 0" v-slot="{ href, navigate, isExactActive }" :to="item.to" custom>
        <Button as-child :variant="isExactActive ? 'secondary' : 'ghost'" :class="orientation === 'vertical' ? 'w-full justify-start' : undefined">
          <a :href="href" :aria-current="isExactActive ? 'page' : undefined" @click="navigateToItem($event, navigate)">
            {{ $t(item.title) }}
          </a>
        </Button>
      </RouterLink>
      <Accordion v-else type="single" collapsible :default-value="item.expanded ? item.id : undefined">
        <AccordionItem :value="item.id" class="border-b-0">
          <AccordionTrigger class="hover:no-underline">
            {{ $t(item.title) }}
          </AccordionTrigger>
          <AccordionContent>
            <div class="ml-0">
              <RecursiveNav :items="item.children" @navigate="emit('navigate')" />
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </template>
  </div>
</template>
